import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IScreen } from "../../../Pages/RoleMappingMaster/IScreen";

export interface RoleScreenlist {
    role_id: number
}

export const RolesScreenlistSlice = createSlice({
    name: "RolesScreenlist",
    initialState: {} as IReduxState<IScreen[]>,
    reducers: {
        getRolesScreenlist: (state, _: PayloadAction<RoleScreenlist>) => {
            state.isLoading = true;
        },
        successRolesScreenlist: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failureRolesScreenlist: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearRolesScreenlist: (state) => {
            state.data = {};
        },
    },
});

export const {
    getRolesScreenlist,
    successRolesScreenlist,
    failureRolesScreenlist,
    clearRolesScreenlist,
} = RolesScreenlistSlice.actions;

export default RolesScreenlistSlice.reducer;
